var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.comp,_vm._b({tag:"component",attrs:{"texts":_vm.texts,"is-busy":_vm.isBusy,"action":_vm.actionModel},on:{"update:action":function($event){_vm.actionModel=$event},"expand":_vm.onExpand,"confirm":_vm.onConfirm,"abort":_vm.onAbort}},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }